<template>
  <v-dialog v-model="dialogVisible" max-width="500px">
    <v-card>
      <v-card-title class="headline d-flex justify-space-between">
        Manage Permissions
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-treeview
          :items="permissionItems"
          item-key="name"
          selectable
          return-object
          selected-color="primary"
        >
        </v-treeview>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="closeDialog">Cancel</v-btn>
        <v-btn color="primary" text @click="savePermissions">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PermissionDialog",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    currentRole: {
      type: Object,
      default: null,
    },
    permission: {
      type: Array,
      required: true,
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    permissionItems() {
      const componentMapping = {
        Dashboard: "DashboardComponent",
        Schedule: "ScheduleComponent",
        Staff: "StaffComponent",
        Clients: "ClientsComponent",
        Reports: "ReportsComponent",
        Calendar: "CalendarComponent",
        Training: "TrainingComponent",
        Task: "TaskComponent",
        Maintenance: "MaintenanceComponent",
        Vehicles: "VehiclesComponent",
        Providers: "ProvidersComponent",
        Payroll: "PayrollComponent",
      };
       return this.permission.map((permissionItem) => {
      // Base item structure
      const baseItem = {
        name: permissionItem,
        children: [{ name: `Can view ${permissionItem.toLowerCase()} page` }],
        component: componentMapping[permissionItem] || null,
      };

      // Add specific children based on the permissionItem
      if (permissionItem === "Schedule") {
        baseItem.children.push(
          { name: "Can add schedule" },
          { name: "Can update schedule" },
          { name: "Can delete schedule" }
        );
      }
      if (permissionItem === "Calendar") {
        baseItem.children.push(
          { name: "Can add event" },
          { name: "Can update event" },
          { name: "Can delete event" }
        );
      }
      if (permissionItem === "Tasks") {
        baseItem.children.push(
          { name: "Can add task" },
          { name: "Can update task" },
          { name: "Can delete task" }
        );
      }
      if (permissionItem === "Maintenance") {
        baseItem.children.push(
          { name: "Can add request" },
          { name: "Can update request" },
          { name: "Can delete request" }
        );
      }
      if (permissionItem === "Vehicles") {
        baseItem.children.push(
          { name: "Can add vehicle" },
          { name: "Can update vehicle" },
          { name: "Can delete vehicle" }
        );
      }
      if (permissionItem === "Providers") {
        baseItem.children.push(
          { name: "Can add provider" },
          { name: "Can update provider" },
          { name: "Can delete provider" }
        );
      }

      // Return the modified base item
      return baseItem;
    });
    },
  },
  methods: {
    closeDialog() {
      this.dialogVisible = false;
    },
    savePermissions() {
      this.$emit("save", this.currentRole);
      this.closeDialog();
    },
  },
};
</script>
